import api, { API_URL, tokenManager } from './api';

// Listar todas as barbearias
export const listarBarbearias = async () => {
  return await api.get('/master/barbearias');
};

// Buscar barbearia específica
export const buscarBarbearia = async (id) => {
  return await api.get(`/master/barbearias/${id}`);
};

// Criar nova barbearia
export const criarBarbearia = async (dados) => {
  return await api.post('/master/barbearias', dados);
};

// Editar barbearia
export const editarBarbearia = async (id, dados) => {
  return await api.put(`/master/barbearias/${id}`, dados);
};

// Ativar/Desativar barbearia
export const toggleBarbearia = async (id) => {
  return await api.patch(`/master/barbearias/${id}/toggle`);
};

// Excluir barbearia
export const excluirBarbearia = async (id) => {
  return await api.delete(`/master/barbearias/${id}`);
};

// Criar administrador para barbearia
export const criarAdmin = async (barbeariaId, dados) => {
  return await api.post(`/master/barbearias/${barbeariaId}/admin`, dados);
};

// Obter estatísticas da barbearia
export const obterEstatisticas = async (id) => {
  return await api.get(`/master/barbearias/${id}/stats`);
};

// Upload/remover vídeo do totem
export const uploadKioskVideo = async (id, file) => {
  const form = new FormData();
  form.append('video', file);
  const r = await fetch(`${API_URL}/master/barbearias/${id}/kiosk-video`, {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${tokenManager.get()}`
    },
    body: form
  });
  if (!r.ok) {
    const e = await r.json().catch(() => ({}));
    throw { response: { data: e } };
  }
  return r.json();
};

export const deleteKioskVideo = async (id) => {
  const r = await fetch(`${API_URL}/master/barbearias/${id}/kiosk-video`, {
    method: 'DELETE',
    headers: { Authorization: `Bearer ${tokenManager.get()}` }
  });
  if (!r.ok) {
    const e = await r.json().catch(() => ({}));
    throw { response: { data: e } };
  }
  return r.json();
};

// Configurações Efí Pix
export const salvarEfiConfig = async (id, config) => {
  return await api.post(`/master/barbearias/${id}/efi/config`, config);
};

export const buscarEfiConfig = async (id) => {
  return await api.get(`/master/barbearias/${id}/efi/config`);
};

export const uploadEfiCertificate = async (id, file) => {
  const form = new FormData();
  form.append('certificate', file);
  const r = await fetch(`${API_URL}/master/barbearias/${id}/efi/certificate`, {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${tokenManager.get()}`
    },
    body: form
  });
  if (!r.ok) {
    const e = await r.json().catch(() => ({}));
    throw { response: { data: e } };
  }
  return r.json();
};

export const salvarEfiMasterConfig = async (config) => {
  return await api.post('/master/efi/master/config', config);
};

export const buscarEfiMasterConfig = async () => {
  return await api.get('/master/efi/master/config');
};

export const uploadEfiMasterCertificate = async (file) => {
  const form = new FormData();
  form.append('certificate', file);
  const r = await fetch(`${API_URL}/master/efi/master/certificate`, {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${tokenManager.get()}`
    },
    body: form
  });
  if (!r.ok) {
    const e = await r.json().catch(() => ({}));
    throw { response: { data: e } };
  }
  return r.json();
};

// Obter estatísticas do dashboard master
export const obterDashboardEstatisticas = async () => {
  return await api.get('/master/dashboard/estatisticas');
};

const masterService = {
  listarBarbearias,
  buscarBarbearia,
  criarBarbearia,
  editarBarbearia,
  toggleBarbearia,
  excluirBarbearia,
  criarAdmin,
  obterEstatisticas,
  uploadKioskVideo,
  deleteKioskVideo,
  salvarEfiConfig,
  buscarEfiConfig,
  uploadEfiCertificate,
  salvarEfiMasterConfig,
  buscarEfiMasterConfig,
  uploadEfiMasterCertificate,
  obterDashboardEstatisticas
};

export default masterService;

